import React from 'react';
import { ProgressBar, ProgressBarInner, ProgressContainer, ProgressValue, } from './styles/progress.styled';
/**
 * The progress component can be used to display progress.
 */
const Progress = ({ percentage = 0, showPercentage = true }) => (React.createElement(ProgressContainer, { className: "PONCHO-progress" },
    showPercentage && (React.createElement(ProgressValue, { className: "PONCHO-progress__value" },
        percentage,
        "%")),
    React.createElement(ProgressBar, { className: "PONCHO-progress__bar" },
        React.createElement(ProgressBarInner, { className: "PONCHO-progress__bar-inner", role: "progressbar", "aria-valuenow": percentage, "aria-label": "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "$percentage": percentage, "$isFull": percentage === 100 }))));
Progress.defaultProps = {
    percentage: 0,
};
export default Progress;
//# sourceMappingURL=Progress.js.map